// Force a clean reload of the PWA.
//
// A normal browser refresh can still serve stale, precached assets because a
// service worker is in control. After a deploy (new frontend build and/or new
// Convex functions), use forceRefreshApp() to: ask the service worker to check
// for an update and activate any waiting worker, drop every Cache Storage
// bucket (Workbox precache + runtime caches like convex-api), then reload so
// the freshest assets and function clients are loaded from the network.

export async function forceRefreshApp(reload) {
  const doReload = typeof reload === 'function'
    ? reload
    : () => window.location.reload()
  try {
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map(async (r) => {
        try {
          await r.update()
          // If an updated worker is parked in "waiting", let it take over now.
          if (r.waiting) r.waiting.postMessage({ type: 'SKIP_WAITING' })
        } catch {
          // Ignore per-registration failures; the reload below still helps.
        }
      }))
    }
    if (typeof caches !== 'undefined' && caches && caches.keys) {
      const keys = await caches.keys()
      await Promise.all(keys.map((k) => caches.delete(k)))
    }
  } catch (err) {
    // Best-effort cleanup — never block the reload on it.
    console.warn('[Teddo] force refresh cleanup failed:', err)
  } finally {
    doReload()
  }
}

// Build-time stamps injected by Vite `define`. Guarded with typeof so the app
// still runs in contexts where they aren't defined (e.g. unit tests).
export function getAppVersion() {
  // eslint-disable-next-line no-undef
  return typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev'
}

export function getBuildTime() {
  // eslint-disable-next-line no-undef
  return typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : ''
}
